import { AlertTriangle } from 'lucide-react';
import { formatPrice } from '@/features/contracts/utils/contractFormatter';
import {
  disputeKindLabel,
  disputeReasonLabel,
  disputeStatusInfo,
  isDisputeOpen,
  type ContractDispute,
} from '@/features/contracts/constants/dispute-labels';

const formatDay = (iso: string) => new Date(iso).toLocaleDateString('fr-FR');

/**
 * Litiges Stripe d'un contrat : statut, montant, motif et dates. Affiché dans la
 * fiche contrat et dans la fiche du dashboard Stripe. Rien si aucun litige.
 */
export function ContractDisputesBlock({ disputes }: { disputes?: ContractDispute[] | null }) {
  if (!disputes || disputes.length === 0) return null;

  return (
    <div className="tw-mt-3 tw-rounded-md tw-border tw-border-red-200 tw-bg-red-50 tw-p-3">
      <div className="tw-flex tw-items-center tw-gap-2 tw-mb-2">
        <AlertTriangle className="tw-w-4 tw-h-4 tw-text-red-600" />
        <h4 className="tw-text-sm tw-font-semibold tw-text-red-800 tw-m-0">
          {disputes.length > 1 ? `Litiges (${disputes.length})` : 'Litige'}
        </h4>
      </div>
      <div className="tw-space-y-2">
        {disputes.map((dispute) => {
          const status = disputeStatusInfo(dispute.status);
          return (
            <div key={dispute.id} className="tw-text-xs tw-text-gray-700">
              <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-2">
                <span className="tw-font-medium tw-text-gray-900">
                  {disputeKindLabel(dispute.paymentMethodType)} de {formatPrice(dispute.amount)}
                </span>
                <span className={`tw-px-2 tw-py-0.5 tw-rounded-full tw-font-medium ${status.color}`}>
                  {status.label}
                </span>
              </div>
              <div className="tw-mt-0.5 tw-text-gray-600">
                Motif : {disputeReasonLabel(dispute.reason)} · ouvert le {formatDay(dispute.disputedAt)}
                {dispute.closedAt && <> · clos le {formatDay(dispute.closedAt)}</>}
                {isDisputeOpen(dispute.status) && dispute.evidenceDueBy && (
                  <> · réponse avant le {formatDay(dispute.evidenceDueBy)}</>
                )}
              </div>
              {dispute.withdrawnAmount > 0 && (
                <div className="tw-mt-0.5 tw-text-red-700">
                  {formatPrice(dispute.withdrawnAmount)} retirés du solde Stripe du vendeur
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
